/**
 * Redux reducer for the luci information.
 * @module redux/reducers/info
 */

import { version } from '../../package.json';
import { REQUEST_INFO, REQUEST_INFO_FAILED, RECEIVED_INFO } from '../actions/info';
import { LOGIN_SUCCESS, RECEIVED_AXIS_USER_PROFILE } from '../actions/auth';

const initialState = {
  username: '',
  licensedOptions: '',
  axisServices: '',
  luciVersion: version,
  camioServer: '',
  camioServerIp: '',
  camioVersion: '',
  serverStatus: false,
  spellCheckerEngine: '',
  spellCheckerEngineCopyright: '',
  chyronCopyright: '',
  loading: false
};

const ACTION_HANDLERS = {
  [REQUEST_INFO]: state => ({
    ...state,
    loading: true
  }),
  [REQUEST_INFO_FAILED]: state => ({
    ...state,
    loading: false
  }),
  [RECEIVED_INFO]: (state, action) => ({
    ...state,
    loading: false,
    username: action.payload.username,
    licensedOptions: action.payload.licensedOptions,
    camioServer: action.payload.camioServer,
    camioServerIp: action.payload.camioServerIp,
    camioVersion: action.payload.camioVersion,
    serverStatus: action.payload.serverStatus,
    chyronCopyright: action.payload.chyronCopyright
  }),
  [LOGIN_SUCCESS]: (state, action) => ({
    ...state,
    username: action.payload.user.username
  }),
  [RECEIVED_AXIS_USER_PROFILE]: (state, action) => ({
    ...state,
    axisServices: action.payload.services.join(', ')
  })
};

export default function info(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./app/reducers/info.js